import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { PackageEntryStatus } from '../../../types/packager-types';

type IUsePackageEntryUpdateProps = {
  id: string;
  status_in_package: PackageEntryStatus;
  exclusion_reason?: string | null;
};

export const usePackageEntryUpdate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IUsePackageEntryUpdateProps) => {
      return await (
        await glynt
      ).packages.updatePackageEntry(data.id, {
        status_in_package: data.status_in_package,
        exclusion_reason: data.exclusion_reason,
      });
    },

    ...callbacks
  });
};

export default usePackageEntryUpdate;
